import { render, staticRenderFns } from "./IntegralMall.vue?vue&type=template&id=382f3972&scoped=true"
import script from "./IntegralMall.vue?vue&type=script&lang=js"
export * from "./IntegralMall.vue?vue&type=script&lang=js"
import style0 from "./IntegralMall.vue?vue&type=style&index=0&id=382f3972&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382f3972",
  null
  
)

export default component.exports